// app/frontend/components/ui/Inputs/ThemedTimeInput.tsx
import React, { forwardRef } from 'react';
import { TimeInput, TimeInputProps } from '@mantine/dates';
import '../../../styles/ThemedInputs.css';
import { COLORS, INPUT_LABEL_FONT_SIZE } from '../../../src/constants/theme';

export interface ThemedTimeInputProps extends Omit<TimeInputProps, 'styles'> {
  label?: string;
  placeholder?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  description?: string;
  error?: string;
}

const ThemedTimeInput = forwardRef<HTMLInputElement, ThemedTimeInputProps>((props, ref) => {
  return (
    <TimeInput
      {...props}
      ref={ref}
      className="themed-time-input"
      styles={{
        label: {
          color: '#f2f2f2',
          marginBottom: '4px',
          fontWeight: 500,
          fontSize: INPUT_LABEL_FONT_SIZE,
          fontFamily: 'Poppins, sans-serif',
        },
        description: {
          color: '#d1d1d1',
          fontSize: '14px',
          marginTop: '4px',
          fontFamily: 'Poppins, sans-serif',
        },
        error: {
          color: '#ff6b6b',
          fontSize: '14px',
          marginTop: '4px',
          fontFamily: 'Poppins, sans-serif',
        },
        input: {
          backgroundColor: 'rgba(30, 30, 30, 0.6)',
          borderColor: 'rgba(255, 255, 255, 0.12)',
          fontSize: '14px',
          color: '#f2f2f2',
          fontFamily: 'Poppins, sans-serif',
          '&:focus': {
            borderColor: '#EA580C',
          },
          '&::placeholder': {
            fontSize: '14px',
            color: COLORS.textDimmed,
            fontFamily: 'Poppins, sans-serif',
          },
        },
      }}
    />
  );
});

ThemedTimeInput.displayName = 'ThemedTimeInput';

export default ThemedTimeInput;
